<app-tab [activeTab]="'tab1'" [tabs]="tabsFlujos"
    [tabTemplates]="{ tab1: tab1TemplateFlow, tab2: tab2TemplateFlow, tab3: tab3TemplateFlow }"
    [accionIconRight]="accionIconRightTblFlujo" [accionIconLeft]="accionIconLeftTblFlujo" [separador]="true"
    (clickIcon)="editFlujo($event)" (clickTab)="clickTabFlujo($event)">
    <ng-template #tab1TemplateFlow>
        <div class="content-flow">
            <app-approval-flow [status]="'pending'" [user]="flujoAprobacion.NombreCreador"
                [typeUser]="'Solicitante'"></app-approval-flow>
            <div *ngFor="let aprobador of flujoAprobacion.Aprobadores; let i = index">
                <app-approval-flow [status]="aprobador.Aprobo?'process':'pending'" [user]="aprobador.NombreUsuario"
                    [typeUser]="'Aprobador ' + (i+1)"
                    [isLast]="(i+1) == flujoAprobacion.Aprobadores.length? true: false"
                    [showLabel]="aprobador.Comentario?true:false" [positionPopover]="'right'" 
                    [tituloPopover]="'Comentario'" [mensajePopover]="aprobador.Comentario"></app-approval-flow>
            </div>
        </div>
    </ng-template>
    <ng-template #tab2TemplateFlow>
        <div style="display: flex; justify-content: center; padding: 16px 0px; flex-direction: column;">
            <app-table id="tablePresupuestoRecurso" [dataShowItem]="dataListadoRecurso"
                [dataConfig]="dataConfigPresupuestoRecurso">
            </app-table>
        </div>
    </ng-template>
    <ng-template #tab3TemplateFlow>
        <div style="display: flex; justify-content: center; padding: 16px 0px;">
            <app-table id="tablePresupuestoCuenta" [dataShowItem]="dataListadoCuenta"
                [dataConfig]="dataConfigPresupuestoCuenta">
            </app-table>
        </div>
    </ng-template>
</app-tab>